
import {
  Component, OnInit, Input, Output, OnChanges, EventEmitter,
  Directive, ViewContainerRef, ViewChildren, QueryList, ComponentFactoryResolver, AfterContentInit, ComponentRef, AfterViewInit
} from '@angular/core';
import { BusinessunitService } from '../../Master/businessunit/businessunit.service';
import { ToastrService } from 'ngx-toastr';
import { Businessunit } from '../../Master/businessunit/businessunit';
import { ProductService } from '../../Master/product/product.service';
import { Product } from '../../Master/product/product';
import $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { RequestconfigService } from '../../../app/configuration/requestconfig/requestconfig.service';
import { RequestconfigModel, ConversionrequestDetail } from '../../../app/configuration/requestconfig/requestconfig';
import { Database } from '../../Master/database/database';
import { DatabaseService } from '../../Master/database/database.service';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { CostCenter } from '../../Master/costcenter/costcenter';
import { CostcenterService } from '../../Master/costcenter/costcenter.service';
import { ProductgroupService } from '../../Master/productgroup/productgroup.service';
import { ProductGroup } from '../../Master/productgroup/productgroup';
import { TypeService } from '../../Master/type/type.service';
import { Type } from '../../Master/type/type';
import { DatePipe } from '@angular/common';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { UseraddService } from '../../Master/useradd/useradd.service';
import { FormrenderService } from '../../formrender/formrender.service';
import { FormdashboardService } from '../../dashboard/formdashboard/formdashboard.service';
import { requeststatus } from '../../dashboard/requestdashboard/requeststatus';
import { RequestdashboardService } from '../../dashboard/requestdashboard/requestdashboard.service';
import { saveFile, saveAs } from 'file-saver';
import { location } from 'ngx-bootstrap/utils/facade/browser';
import { ProductdetailsComponent } from '../../../app/configuration/requestconfig/productdetails/productdetails.component';
import { LocalService } from '../../local.service';

//@Directive({
//  // tslint:disable-next-line:directive-selector
//  selector: '[productdatacontainer]',
//})
//export class productDatacontainerDirective {
//  constructor(public viewContainerRef: ViewContainerRef) {
//  }
//}

@Component({
  selector: 'app-viewarbitration',
  templateUrl: './viewarbitration.component.html',
  styleUrls: ['./viewarbitration.component.css']
})
export class ViewarbitrationComponent implements OnInit, AfterViewInit {

  sendMenuId: number;
  sendPageName: string = 'View Arbitration';
  _actionRights: any;
  submitShow: boolean;
 
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean; _menuId: any;
  businessUnits: Businessunit[]; today: number = Date.now(); products: Product[] = [];
  _dropdownSettings: any
  requestType = false; requestinfoshow = false; downloadInstrshow = false; documentInfo = false;
  otherCites = false; queryDetails = false
  details = false; conversionInfo = true; filename = false;
  costlimitations = false;
  selectall = false;
  requestConfigForm: FormGroup; conversiondetailsForm: FormGroup; requestConfig: RequestconfigModel;
  databases: any = []; dbid: number = 0; 
  //public username = localStorage.getItem('username');
  public username = this.localService.getJsonValue('username');
  costCenters: CostCenter[]; ProductGroups: ProductGroup[]
  types: Type[]
  dirPaths: string[] = []; selectprod: Product; deselectProd: Product;
  queryObj: any; requestDetails: any;
  operationType = 'add';
  requestdetailid: number; requesttypeid: number;
  bsInlineValue = new Date();
  desiredCompDate: any;
  //query param
  documentId: number = 0;
  formConfigId: number = 0;
  requestTypeId: number = 0;

  formName: string = '';
  descisionDatetextvalue: Date;
  requestinfoContent = true; downloadInstrContent = true; documentInfoContent = true;
  otherCitesContent = true; detailsContent = true;
  conversionInfoContent = true; queryDetailsContent = true
  requestinfo = false;
  domesticInfo = false;
  otherCite = false;
  costcenter = false;
  subject = false;
  reqreport = false;
  reqparagraph = false;
  reqprodformat = false;
  reqcostcenter = false;
  reqprodgroup = false;
  reqprodname = false;
  items: any; _usermappedDatabase = [];
  userid: number;
  check: boolean = false;
  selectedProducts: Product[] = [];
  editProductsname: Product = new Product();
  productname: string = '';
  attachedFileList: any = [];
  requeststatus: requeststatus = new requeststatus();
  conversionuser: boolean = false;
  outputFormatbinding: boolean = false;
  viewrequest: boolean = false;
  documentinfodesiredCompDateValue: any; docInfoDescisionopinionDateValue: any;
  detailsdesiredcompletiondatevalue: any; querydetailsdesiredcompletiondatevalue: any
  conversionDocUpload: boolean = false;
  attachfilepath: string = '';
  attachfileName: string = '';
  attachconversionfileName: string = '';
  finaluploadfilenameedit: string = '';
  finaluploadfilename: string = '';
  attachconversionfilepath: string = '';
  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  selectedproduct: string = '';
  //@ViewChildren(productDatacontainerDirective) entry: QueryList<productDatacontainerDirective>;
  product: ConversionrequestDetail[] = [];
  proceedconversion: boolean = false;

  childcreatedproduct: { productid: number, index: number }[] = [];
  //Constructor
  constructor(private businessUnitService: BusinessunitService, private toastr: ToastrService,
    private productsService: ProductService, private router: Router,
    private _frmBuilder: FormBuilder, private requestConfigService: RequestconfigService,
    private route: ActivatedRoute, private databaseService: DatabaseService, private dialogService: DialogService,
    private typeService: TypeService, private productGroupService: ProductgroupService,
    private costcenterservice: CostcenterService, private datePipe: DatePipe,
    private useraddService: UseraddService,
    private formRenderService: FormrenderService,
    private formdashboardservice: FormdashboardService,
    private requestdashboardservice: RequestdashboardService, private resolver: ComponentFactoryResolver,
    private localService: LocalService
    ) {

    //code to get relavent menu id
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Team Management_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Team Management_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Team Management_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Team Management_action');
    }



  }

  //code to get action rights
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  //Event after init
  ngAfterViewInit() {

    if (this.queryObj.params.requestid != undefined) {
      this.getRequestDatabasedonId();
    }

    this.route.queryParamMap.subscribe(params => {
      this.queryObj = params;
      //console.log(this.queryObj.params.documentId, this.queryObj.params.formConfigId);
      // this.requestdetailid = this.queryObj.params.requestid; this.requesttypeid = this.queryObj.params.requesttypeid;
    });
    if ((this.documentId != undefined) && (this.formConfigId != undefined)) {
      this.requestTypeId = this.requesttypeid;
      // this.getRequestDatabasedonId();
      if (this.requestTypeId != 0) {
        if (this.requestTypeId == 1) {
          var event = { currentTarget: { id: 'courtOpenionReqChk', checked: true } };
          this.requestConfigForm.controls['courtagoopinionrequeststatus'].setValue(true);
          $("#courtOpenionReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 2) {
          var event = { currentTarget: { id: 'researchGroupReqChk', checked: true } };
          this.requestConfigForm.controls['researchgrouprequeststatus'].setValue(true);
          $("#researchGroupReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 3) {
          var event = { currentTarget: { id: 'informationReqChk', checked: true } };
          this.requestConfigForm.controls['informationrequeststatus'].setValue(true);
          $("#informationReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 4) {
          var event = { currentTarget: { id: 'internetDownloadReqChk', checked: true } };
          this.requestConfigForm.controls['internetdownloadrequeststatus'].setValue(true);
          $("#internetDownloadReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        if (this.requestTypeId == 5) {
          var event = { currentTarget: { id: 'conversionReqChk', checked: true } };
          this.requestConfigForm.controls['conversionrequeststatus'].setValue(true);
          $("#conversionReqChk").prop('checked', 'true');
          this.selectRequestType(event)
        }
        //this.requestConfigForm.controls['dbid'].setValue(this.dbid);
        this.loadFileDetails();
      }
    }


  }

  //Event onint
  ngOnInit() {

    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid')
    this.route.queryParamMap.subscribe(params => {
      this.queryObj = params;
      this.requestdetailid = this.queryObj.params.requestid; this.requesttypeid = this.queryObj.params.requesttypeid;
      this.dbid = +this.queryObj.params.db;
      this.documentId = this.queryObj.params.documentId; this.formConfigId = this.queryObj.params.formConfigId;
      this.formName = this.queryObj.params.formName;
      if (this.queryObj.params.redirectmode == 'conversionuser') {
        this.conversionuser = true;
        this.viewrequest = true;
      }
      else
        this.conversionuser = false;
      if (this.queryObj.params.redirectmode == 'viewrequest') {
        this.viewrequest = true;
      }
    });

    if (this.queryObj.params.requestid != undefined) {
      this.operationType = 'update';
    }

    this.InitializeControls();
    this.getActiveBusinessUnits();
    this.getActiveProducts();

    this.getDatabases();
   // this.getCostCenters();
    //this.getProductGroup();
   // this.getTypeDetails();




    this._dropdownSettings = {
      singleSelection: false,
      idField: 'productid',
      textField: 'product',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit:2,
      allowSearchFilter: true
    };

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();

    if (this.queryObj.params.requestid != undefined) {
      this.operationType = 'update';
      this.getRequestDatabasedonId();
    }

    this.dpConfig = {
      isAnimated: true, adaptivePosition: true, containerClass: 'theme-dark-blue', dateInputFormat: 'MM/DD/YYYY'
    }
    //$('body').addClass('nav-sm').removeClass('nav-md');
    if (this.requesttypeid == 5)
      this.conversionInfo = true;
  }

  //Code to initialize controls
  InitializeControls() {
    this.requestConfigForm = this._frmBuilder.group({
      dbid: [0, Validators.required],
      courtagoopinionrequeststatus: [false],
      researchgrouprequeststatus: [false],
      informationrequeststatus: [false],
      internetdownloadrequeststatus: [false],
      conversionrequeststatus: [false],
      businessunit: [0, Validators.required],
      product: ['', [Validators.required]],
      report: ['', [Validators.required]],
      paragraph: ['', [Validators.required]],
      productformat: ['', Validators.required],
      printonly: ['', Validators.required],
      electroniconly: ['', Validators.required],
      printandelectronic: ['', Validators.required],
      documentinfo__desiredcompletiondate: [Validators.required],
      documentinfo_samedayturnaround: [false, Validators.required],
      courtagoopinion: [Validators.required],
      courtopinion: [false, Validators.required],
      ago: [false, Validators.required],
      //Opiniontype: ['', Validators.required],
      docketoragonumber: ['', Validators.required],
      descisionopiniondate: [Validators.required],
      courtoragoissuingstate: ['', Validators.required],
      casenameoragosubject: ['', Validators.required],
      judgesname: ['', Validators.required],
      westcite: ['', Validators.required],
      westlawcite: ['', Validators.required],
      lexiscite: ['', Validators.required],
      taxanalysiscite: ['', Validators.required],
      url: ['', Validators.required],
      othersources: ['', Validators.required],
      documentinfo_editorscomments: ['', Validators.required],
      conversionFile: [''],
      productgroup: [0],
      costcenter: [0],
      filename: ['', Validators.required],
      detaileddescriptionofrequest: ['', Validators.required],
      attachfile: ['', Validators.required],
      shortdescriptionforyourreference: ['', Validators.required],
      detailsdesiredcompletiondate: [Validators.required],
      detailssamedayturnaround: ['', Validators.required],
      searchtermkeywords: ['', Validators.required],
      desirednumberofhits: ['', Validators.required],
      costlimitations: ['', Validators.required],

      querydetailsdesiredcompletiondate: [Validators.required],
      querydetailssamedayturnaround: [false, Validators.required],
      request: ['', Validators.required],
      querydetailseditorscomments: ['', Validators.required],
      subject: ['', Validators.required],
      conversionreqdocid: [''],
      conversionreqattachfile: [''],
      dtlsFileUpld: [''],
      urlofdesireddocument: ['', Validators.required],
      downloadinformationeditorscomments: ['', Validators.required],
      detaileddescriptionforuseifurlisinvalid: ['', Validators.required],
      // productdetails: this._frmBuilder.array([])
    })
    
  }

  //code to bind data on edit
  getRequestDatabasedonId() {
    this.requestConfigService.GetById(+this.queryObj.params.requestid, +this.queryObj.params.requesttypeid).toPromise().then(res => {

      this.requestDetails = res;
      //console.log(this.requestDetails);
      this.requestDetails = JSON.parse(this.requestDetails[0].j);

      //disable all request checkboxes
      $("#courtOpenionReqChk").prop('disabled', 'true');
      $("#researchGroupReqChk").prop('disabled', 'true');
      $("#informationReqChk").prop('disabled', 'true');
      $("#internetDownloadReqChk").prop('disabled', 'true');
      $("#conversionReqChk").prop('disabled', 'true');


      if (this.requestDetails) {
        this.username = this.requestDetails[0].firstname;
        this.today = this.requestDetails[0].createdon;
        this.dbid = +this.requestDetails[0].dbid;
        this.requestConfigForm.controls['dbid'].setValue(this.requestDetails[0].dbid);
        $("#dbid").prop('disabled', 'true');
        if (this.requestDetails[0].productname)
          this.selectedProducts = this.getcustomlist(this.requestDetails[0].productname, 'product');
        this.documentId = this.requestDetails[0].documentid
        if (this.requestDetails[0].documentmode != 'direct') {
          this.formName = this.requestDetails[0].documentmode

          this.loadFileDetails();
        }

        if (this.requestDetails[0].courtagoopinionrequestid) {
          //$('#courtOpenionReqChk').prop('checked', true)
          this.requestConfigForm.controls['courtagoopinionrequeststatus'].setValue(true);
          var event = { currentTarget: { id: 'courtOpenionReqChk', checked: true } };
          //console.log(event.currentTarget.id)
          this.selectRequestType(event)
          //this.selectRequestType(event);
          this.requestConfigForm.controls['businessunit'].setValue(this.requestDetails[0].businessunit);
          this.selectedProducts = this.requestDetails[0].productname
          this.selectedProducts = this.getcustomlist(this.requestDetails[0].productname, 'product');
          this.requestConfigForm.controls['product'].setValue(this.selectedProducts);
          this.requestConfigForm.controls['report'].setValue(this.requestDetails[0].report);
          this.requestConfigForm.controls['paragraph'].setValue(this.requestDetails[0].paragraph);
          this.finaluploadfilenameedit = this.requestDetails[0].finalupload;
          var prodformar = this.requestDetails[0].productformat

          if (this.requestDetails[0].samedayturnaround === 1)
            this.requestConfigForm.controls['documentinfo_samedayturnaround'].setValue(true);
          else {
            this.requestConfigForm.controls['documentinfo_samedayturnaround'].setValue(false);
          }

          var courtagores = this.requestDetails[0].courtoragoopinion;
          if (courtagores == 1) {
            $('#docInfocrtopnRadio').prop("checked", true);
          }
          else if (courtagores == 2) {
            $('#docInfoagoRadio').prop("checked", true);
          }


          //console.log(this.datePipe.transform(this.requestDetails[0].desiredcompletiondate, "MM/dd/yyyy"));
          //this.requestConfigForm.controls['documentinfo__desiredcompletiondate'].setValue(this.requestDetails[0].desiredcompletiondate);
          this.docInfoDescisionopinionDateValue = this.datePipe.transform(this.requestDetails[0].descisionopinion, "MM/dd/yyyy");
          this.documentinfodesiredCompDateValue = this.datePipe.transform(this.requestDetails[0].desiredcompletiondate, "MM/dd/yyyy");
          this.requestConfigForm.controls['docketoragonumber'].setValue(this.requestDetails[0].docketagonumber);
          this.requestConfigForm.controls['descisionopiniondate'].setValue(this.requestDetails[0].descisionopinion);
          this.requestConfigForm.controls['courtoragoissuingstate'].setValue(this.requestDetails[0].courtagoissuingstate);

          this.requestConfigForm.controls['casenameoragosubject'].setValue(this.requestDetails[0].casenameagosubject);
          this.requestConfigForm.controls['judgesname'].setValue(this.requestDetails[0].judgesname);
          this.requestConfigForm.controls['westcite'].setValue(this.requestDetails[0].westcite);
          this.requestConfigForm.controls['westlawcite'].setValue(this.requestDetails[0].westlawcite);
          this.requestConfigForm.controls['lexiscite'].setValue(this.requestDetails[0].lexiscite);
          this.requestConfigForm.controls['taxanalysiscite'].setValue(this.requestDetails[0].taxanalystscite);
          this.requestConfigForm.controls['url'].setValue(this.requestDetails[0].url);
          this.requestConfigForm.controls['othersources'].setValue(this.requestDetails[0].othersource);
          this.requestConfigForm.controls['documentinfo_editorscomments'].setValue(this.requestDetails[0].editorscommnets);
        }

      
      }









      // alert(this.requestDetails[0].documentid);
      // console.log(this.requestDetails.documentid);
    },
      err => { this.toastr.error('Error to Get Request Details') })

  }


  //editproductcomponentcalling() {



  //  var editProductsname = this.products.find(item => item.productid === this.requestDetails[0].productid);
  //  var editproductname = editProductsname.product;
  //  var editdirpath = editProductsname.dirpath;


  //  const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
  //  var id = this.requestDetails[0].productid;
  //  var i = 0
  //  this.entry.forEach(container => {
  //    //let containerid = this.entry.element.nativeElement.id;
  //    const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
  //    this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = this.requestDetails[0].productid;
  //    myRef.instance['productid'] = this.requestDetails[0].productid;
  //    myRef.instance['productname'] = editproductname;
  //    myRef.instance['directorypath'] = editdirpath;
  //    myRef.instance['operation'] = 'edit';
  //    myRef.instance['productdetailsedit'] = this.requestDetails;
  //    // i = i + 1;
  //  });
  //}



  //form valid mail structure suit for  multi select list
  getcustomlist(idlist, type) {

    var tempList = [];
    if (type == 'product') {

      if ((idlist != null) && (idlist.length != 0)) {
        idlist.forEach((d) => {
          this.products.forEach((data, ind) => {
            if (data.productid == d.productid) {
              tempList.push({
                productid: data.productid, product: data.product
              });
            }
          });
        });
      }
    }

    return tempList;
  }



  //Code to add product
  addProduct(data: Product): void {
    this.selectprod = this.products.find(item => item.productid === data.productid) as Product;

    //(<FormArray>this.requestConfigForm.get('productdetails')).push(this.createProduct());
    //this.items = this.requestConfigForm.get('productdetails') as FormArray;
    //if (this.dirPaths.indexOf(this.selectprod.dirpath) === -1)
    //  this.dirPaths.push(this.selectprod.dirpath);

    //this.items.at(this.items.length - 1).controls['productid'].setValue(this.selectprod.productid);
    //this.items.at(this.items.length - 1).controls['product'].setValue(this.selectprod.product);

  }

  //Code to return records from masters
  //Costcenter master
  getCostCenters() {
    this.costcenterservice.Get().subscribe(res => {
      this.costCenters = res;
      this.costCenters = this.costCenters.filter(
        costcenter => costcenter.active === 1);
    }, error => { this.toastr.error('Error while getting data'); });

  }

  //Product group master
  getProductGroup() {

    this.productGroupService.Get().subscribe(res => {

      this.ProductGroups = res
      this.ProductGroups = this.ProductGroups.filter(
        item => item.active === 1);
    }, err => {
      this.toastr.error('unable to get product Group Data')
    })


  }

  //type details master
  getTypeDetails() {
    this.typeService.Get().subscribe(res => {
      this.types = res
      this.types = this.types.filter(
        item => item.active === 1);

    }, err => {
      this.toastr.error('error while getting Type Data')
    })
  }

  getActiveBusinessUnits() {
    this.businessUnitService.GetActives().subscribe(res => {
      this.businessUnits = res
    }, error => {
      this.toastr.error('Unable to get business unit data');
    })
  }

  getActiveProducts() {
    this.productsService.GetActive().subscribe(res => {
      this.products = res
      //console.log(this.products)

    }, error => {
      this.toastr.error('Unable to get product data');
    })
  }

  getDatabases() {
    this.databaseService.getActive().subscribe(res => {
      var allData = res;
      allData.forEach(data => {
        if (data.active != 0) {
        
            this.databases.push({
              databaseid: data.databaseid,
              database: data.database,
              iconclass: data.iconclass,
              databasedescription: data.databasedescription,
              databaseiconpath: data.databaseiconpath,
              status: data.status,
              createdby: data.createdby,
              createdon: data.createdon,
              modifiedby: data.modifiedby,
              modifiedon: data.modifiedon,
              active: data.active,
              databaseicon: data.databaseicon
            });
        }
        // console.log(this.databases);
        if ((this.dbid == 0) || (this.dbid == undefined) || isNaN(this.dbid)) {
          this.route.params.subscribe(params => {
            this.dbid = +params['db'];
          });
        }

        if (isNaN(this.dbid)) {
          this.requestConfigForm.controls['dbid'].setValue(0);
        }
        else {
          this.requestConfigForm.controls['dbid'].setValue(this.dbid);
        }
      });
      //this.useraddService.GetById(this.userid).subscribe(res => {
      //  let user: any = [];
      //  user = res.find(y => y.userid == this.userid);
      //  this._usermappedDatabase = JSON.parse(user.databasemapped).databasemapped;
      //  if ((this._usermappedDatabase != undefined) && (this._usermappedDatabase != null) &&
      //    (this._usermappedDatabase.length > 0)) {
         
      //  }
      //  else {
      //    this.databases = [];
      //  }
      //});

    },
      err => {
        this.toastr.error('Not able to get Database Data')
      })

  }

  //productclear() {
  //  this.products.forEach(product => {
  //    this.entry.forEach(container => {
  //      container.viewContainerRef.clear();
  //    });
  //  })
  //}
  //Code to save (Add/Update) data
  //postRequestConfig(data: RequestconfigModel, ) {

  //  if (this.requestConfigForm.value.courtagoopinionrequeststatus === false && this.requestConfigForm.value.researchgrouprequeststatus === false && this.requestConfigForm.value.informationrequeststatus === false &&
  //    this.requestConfigForm.value.internetdownloadrequeststatus === false && this.requestConfigForm.value.conversionrequeststatus === false) {
  //    this.toastr.error('Please select atleast one request to Proceed')
  //    return;
  //  }
  //  if (this.requestConfigForm.value.dbid == '0') {
  //    this.toastr.error('Please select Database')
  //    return;
  //  }
  //  if (this.requestConfigForm.value.businessunit === 0) {
  //    this.toastr.error('Please select Business Unit')
  //    return;
  //  }

  //  var prdctformat = []
  //  if (this.requestConfigForm.value.conversionrequeststatus === true && this.selectedProducts.length <= 0) {
  //    this.toastr.error('Please select atleast one product Conversion Request');
  //    return;
  //  }

  //  $.each($("div#productFormat input[type=checkbox]"), function (a, b) {
  //    var obj = {};
  //    obj['name'] = $(this).attr("name")
  //    obj['value'] = $(this).prop("checked") == true ? 1 : 0

  //    prdctformat.push(obj)

  //  });


  //  var a = $('div#courtagoOpenion input[name=courtagoopinion]:checked').val();
  //  if (a === 'CourtOpinion') {
  //    data.courtagoopinion = 1
  //  }
  //  else if ((a === 'AGO')) {
  //    data.courtagoopinion = 2
  //  }


  //  data.productformat = JSON.stringify(prdctformat);

  //  this.selectedProducts.forEach(function (v) { delete v.product });
  //  data.product = JSON.stringify(this.selectedProducts);


  //  if (data.documentinfo_samedayturnaround) {
  //    data.documentinfo_samedayturnaround = 1
  //  }
  //  else {
  //    data.documentinfo_samedayturnaround = 0
  //  }
  //  if (data.detailssamedayturnaround) {
  //    data.detailssamedayturnaround = 1
  //  }
  //  else {
  //    data.detailssamedayturnaround = 0
  //  }


  //  if (data.querydetailssamedayturnaround) {
  //    data.querydetailssamedayturnaround = 1
  //  }
  //  else {
  //    data.querydetailssamedayturnaround = 0
  //  }

  //  var outputformat = []
  //  //$.each($("div#conversioninfoContentDiv input[type=checkbox]"), function (a, b) {



  //  //for (let i = 0; i < data.productdetails.length; i++) {
  //  //  data.productdetails[i].active = 1;

  //  //  if (this.operationType === 'add') {
  //  //    data.productdetails[i].createdon = new Date().toDateString();
  //  //    data.productdetails[i].createdby = +localStorage.getItem("userid");
  //  //  }
  //  //  if (this.operationType === 'update') {
  //  //    data.productdetails[i].modifiedon = new Date().toDateString();
  //  //    data.productdetails[i].modifiedby = +localStorage.getItem("userid");
  //  //  }

  //  //  if ($('#productsamedayturnaround' + i).prop("checked") == true) {
  //  //    data.productdetails[i].productsamedayturnaround = 1

  //  //  }

  //  //  else {
  //  //    data.productdetails[i].productsamedayturnaround = 0
  //  //  }

  //  //  data.productdetails[i].productdesiredcompletiondate = $('#productdesiredcompletiondate' + i).val();

  //  //  $.each($('div#' + 'outputformatDiv' + i + ' input[type=checkbox]'), function (a, b) {
  //  //    var obj = {};
  //  //    obj['name'] = $(this).attr("name")
  //  //    obj['value'] = $(this).prop("checked") == true ? 1 : 0

  //  //    outputformat.push(obj)
  //  //  })

  //  //  data.productdetails[i].outputfiles = JSON.stringify(outputformat)
  //  //  outputformat = []
  //  //}

  //  data.productdetails = [];
  //  this.selectedProducts.forEach(selproduct => {
  //    this.entry.forEach(container => {
  //      let containerid = container.viewContainerRef.element.nativeElement.id;
  //      if (containerid == selproduct.productid) {
  //        if (container.viewContainerRef !== undefined) {
  //          if (container.viewContainerRef['_embeddedViews'].length != 0) {
  //            for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
  //              if (container.viewContainerRef['_embeddedViews'][i] != undefined) {
  //                data.productdetails.push(container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getproductdetails());
  //              }
  //            }
  //          }
  //        }

  //      }
  //    });


  //  });



  //  //});


  //  //data.productdetails = JSON.stringify(outputformat)
  //  data.createdby = +localStorage.getItem("userid");
  //  if ((this.documentId != 0) && (this.documentId != undefined)) {
  //    data.documentid = this.documentId;
  //    data.documentmode = this.formName;
  //  } else {
  //    data.documentmode = 'direct';
  //  }
  //  data.proceedconversion = 0;
  //  data.attachfile = this.attachfileName;
  //  data.conversionreqattachfile = this.attachconversionfileName;

  //  if (this.proceedconversion == true) {
  //    if ($('#conversionReqChk').is(':checked')) {
  //    }
  //    else {
  //      this.toastr.error("Please enter conversion related details");
  //      return;
  //    }
  //  }

  //  if ((this.requestConfigForm.value.courtagoopinionrequeststatus === true) &&
  //    (this.requestConfigForm.value.conversionrequeststatus === false) &&
  //    this.proceedconversion == false && this.operationType == 'add') {
  //    let showpopup = this.dialogService.addDialog(CommondialogComponent,
  //      {
  //        title: 'Please Confirm',
  //        message: 'Do you want to proceed with coversion after acquisition ?',
  //        hclass: 'modelsuccess',
  //        oktext: 'Yes',
  //        canceltext: 'No',
  //        okshow: true,
  //        cancelshow: true

  //      }).subscribe((isConfirmed) => {
  //        if (isConfirmed) {
  //          this.proceedconversion = true;
  //          //var e = document.getElementById("conversionReqChk");           
  //          //(<HTMLInputElement>e).checked = true;
  //          this.selectedProducts = [];
  //          this.toastr.warning("Please enter details for conversion");
  //          return;
  //        }
  //        else {
  //          this.proceedconversion = false;
  //          this.save(data);
  //        }
  //      });
  //  }
  //  else {

  //    if (this.proceedconversion == true)
  //      data.proceedconversion = 1;
  //    else
  //      data.proceedconversion = 0;
  //    this.save(data);

  //  }

  //}


  //save(data) {

  //  if (this.requestConfigForm.value.conversionrequeststatus == true && this.attachconversionfilepath == '' && this.attachconversionfileName == '' && this.attachedFileList.length == 0 && data.proceedconversion == 0) {
  //    this.toastr.error('Please upload the file to Proceed Conversion Request');
  //    return;
  //  }

  //  if (this.operationType === 'add') {
  //    //data.productdetails

  //    this.requestConfigService.Post(data).subscribe(res => {
  //      if (res.body.retval != 0) {
  //        this.toastr.success('Request Form added successfully')
  //        this.productclear();
  //        //this.requestConfigForm.reset();
  //        if (this.requestConfigForm.get('dtlsFileUpld').value != null || this.requestConfigForm.get('conversionreqattachfile').value != null) {
  //          const formData = new FormData();
  //          if (this.requestConfigForm.get('dtlsFileUpld').value != null)
  //            formData.set('dtlsFileUpld', this.requestConfigForm.get('dtlsFileUpld').value);
  //          if (this.requestConfigForm.get('conversionreqattachfile').value != null)
  //            formData.set('conversionreqattachfile', this.requestConfigForm.get('conversionreqattachfile').value);
  //          var s = this.databases.filter(e => e.databaseid == data.dbid)
  //          formData.append('dbname', s[0].database);
  //          formData.append('requestdetailid', res.body.retval.toString());
  //          formData.append('type', 'create');
  //          this.requestConfigService.PostFile(formData).subscribe(
  //            (res) => {
  //              if (res.body != 0) {

  //              }
  //            }, error => {
  //              this.toastr.error("Error while uploading File uploaded during creation");
  //            });

  //        }
  //        this.InitializeControls();
  //        this.selectedProducts = [];
  //        // (<FormArray>this.requestConfigForm.get('productdetails')).clear();
  //        this.requestConfigForm.controls['businessunit'].setValue(0);
  //        this.requestConfigForm.get('product').setValue([]);
  //        $.each($("div#requestConfigparentdiv input[type=checkbox]"), function (a, b) {
  //          $(this).prop("checked", false)

  //        })
  //        this.requestinfoshow = false; this.otherCites = false; this.documentInfo = false; this.queryDetails = false; this.details = false; this.conversionInfo = false;
  //        this.downloadInstrshow = false;
  //        this.conversionDocUpload = false;
  //        this.documentId = null;
  //        this.proceedconversion = false;
  //      }

  //    },
  //      err => {
  //        this.toastr.error('not able to post the request data')
  //      })
  //  }
  //  if (this.operationType === 'update') {
  //    if ($("#courtOpenionReqChk").prop('checked') == true) {
  //      data.courtagoopinionrequestid = +this.queryObj.params.requestid
  //    }
  //    if ($("#researchGroupReqChk").prop('checked') == true) {
  //      data.researchgrouprequestid = +this.queryObj.params.requestid
  //    }
  //    if ($("#informationReqChk").prop('checked') == true) {
  //      data.informationrequestid = +this.queryObj.params.requestid
  //    }
  //    if ($("#internetDownloadReqChk").prop('checked') == true) {
  //      data.internetdownloadrequestid = +this.queryObj.params.requestid
  //    }
  //    if ($("#internetDownloadReqChk").prop('checked') == true) {
  //      data.internetdownloadrequestid = +this.queryObj.params.requestid
  //    }
  //    if ($("#conversionReqChk").prop('checked') == true) {
  //      data.conversionrequestid = +this.queryObj.params.requestid
  //    }
  //    this.requestConfigService.Put(data).subscribe(res => {
  //      if (res.body != 0) {
  //        this.toastr.success('Request Form updated successfully')
  //        this.productclear();
  //        //this.requestConfigForm.reset();
  //        this.statusupdate(12);
  //        const formData = new FormData();
  //        formData.set('dtlsFileUpld', this.requestConfigForm.get('dtlsFileUpld').value);
  //        var s = this.databases.filter(e => e.databaseid == this.dbid)
  //        formData.append('dbname', s[0].database);
  //        formData.append('requestdetailid', this.requestDetails[0].requesttype + ':' + this.requestdetailid.toString());
  //        formData.append('type', 'edit');
  //        this.requestConfigService.PostFile(formData).subscribe(
  //          (res) => {
  //            if (res.body != 0) {

  //            }
  //          }, error => {
  //            this.toastr.error("Error while uploading File  during editing");
  //          });
  //        this.InitializeControls();
  //        this.selectedProducts = [];
  //        // (<FormArray>this.requestConfigForm.get('productdetails')).clear();
  //        this.requestConfigForm.controls['businessunit'].setValue(0);
  //        this.requestConfigForm.get('product').setValue([]);
  //        $.each($("div#requestConfigparentdiv input[type=checkbox]"), function (a, b) {
  //          $(this).prop("checked", false)

  //        })
  //        this.requestinfoshow = false; this.otherCites = false; this.documentInfo = false; this.queryDetails = false; this.details = false; this.conversionInfo = false;
  //        this.downloadInstrshow = false;
  //        this.proceedconversion = false;
  //        this.router.navigate(['/home/requestdashboard'])

  //      }
  //    }, err => {
  //      this.toastr.error('not able to update the request data')

  //    })
  //  }
  //}

  //Code for events
  selectRequestType(event) {


    switch (event.currentTarget.id) {
      case 'courtOpenionReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true;
          this.otherCites = true;
          this.documentInfo = true
          this.requestinfoContent = true;
          this.otherCitesContent = true;
          this.documentInfoContent = true;
          this.conversionInfo = false;

        }
        else if (event.currentTarget.checked === false) {



          this.otherCites = false;
          this.documentInfo = false;


        }
        break;
      case 'researchGroupReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true;
          this.details = true;
          this.requestinfoContent = true;
          this.detailsContent = true;
          this.costcenter = true;
          this.costlimitations = true;
          this.conversionInfo = false;
        }
        else if (event.currentTarget.checked === false) {

          if ($("#researchGroupReqChk").prop('checked') || $("#informationReqChk").prop('checked')) {
            this.details = true;

          }
          else {
            this.details = false;
          }

          this.costcenter = false;

        }
        break;

      case 'informationReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true; this.queryDetails = true; this.details = true;
          this.requestinfoContent = true; this.queryDetails = true; this.subject = true;
          this.filename = true;
          this.costlimitations = true;
          this.conversionInfo = false;
        }
        else if (event.currentTarget.checked === false) {

          if ($("#researchGroupReqChk").prop('checked') || $("#informationReqChk").prop('checked')) {
            this.details = true;

          }
          else {
            this.details = false;
          }
          this.queryDetails = false; this.subject = false;

        }
        break;
      case 'internetDownloadReqChk':
        if (event.currentTarget.checked) {
          this.requestinfoshow = true; this.downloadInstrshow = true;
          this.requestinfoContent = true; this.downloadInstrContent = true;
          this.conversionInfo = false;

        }
        else if (event.currentTarget.checked === false) {

          this.downloadInstrshow = false;

        }
        break;
      case 'conversionReqChk':
        if (event.currentTarget.checked) {
          this.conversionDocUpload = true;
          //if (this.selectedProducts.length > 0) {
          this.conversionInfo = true;
          this.selectedProducts = [];
          // }

        }
        else if (event.currentTarget.checked === false) {

          this.conversionDocUpload = false;
          this.conversionInfo = false;
          this.selectedProducts = [];
        }




    }


    var len = $("div#typeofrequest  input[type=checkbox]:checked").length;
    if (len > 0)
      this.requestinfoshow = true;
    else
      this.requestinfoshow = false;



    if ($('#courtOpenionReqChk').is(':checked') || $('#conversionReqChk').is(':checked')) {
      this.reqreport = true;
      this.reqparagraph = true;
      this.reqprodformat = true;
      this.reqprodname = true;

    }
    else {
      this.reqreport = false;
      this.reqparagraph = false;
      this.reqprodformat = false;
      this.reqprodname = false;

    }

    if ($('#researchGroupReqChk').is(':checked')) {
      this.reqcostcenter = true;
      this.reqprodgroup = true;
    }
    else {
      this.reqcostcenter = false;
      this.reqprodgroup = false;
    }






  }

  RequestConfigAcr(type) {

    if (type === 'requestinfo') {

      this.requestinfoContent = !this.requestinfoContent
      //this.requestinfoshow = !this.requestinfoshow;
    }


    if (type === 'downloadinstruction') {

      // this.downloadInstrshow = !this.downloadInstrshow;
      this.downloadInstrContent = !this.downloadInstrContent

    }

    if (type === 'documentinfo') {

      //this.documentInfo = !this.documentInfo;
      this.documentInfoContent = !this.documentInfoContent
    }
    if (type === 'othercites') {

      // this.otherCites = !this.otherCites;
      this.otherCitesContent = !this.otherCitesContent
    }
    if (type === 'details') {
      //this.details = false
      //this.details = !this.details;
      this.detailsContent = !this.detailsContent
    }
    if (type === 'querydetails') {
      this.queryDetailsContent = !this.queryDetailsContent
    }
    if (type === 'conversioninfo') {
      // this.conversionInfo = false
      // this.conversionInfo = !this.conversionInfo;
      this.conversionInfoContent = !this.conversionInfoContent

    }
  }

  onItemSelect(data: Product) {

    if ($("#conversionReqChk").prop('checked')) {
      this.productname = data.product;
      this.conversionInfoContent = true;

      let existItem = this.selectedProducts.filter(item => item.productid === data.productid);
      if (existItem.length === 0) {
        this.selectedProducts.push(data)
      }


      var dirpathrecord = this.products.find(item => item.productid === data.productid);
      var dirpath = dirpathrecord.dirpath;

      var i = 0;
      //if (this.childcreatedproduct.length > 0) {       
      //    const max = this.childcreatedproduct.reduce((prev, current) => (prev.index > current.index) ? prev : current)
      //    i = max.index;
      //    i = i + 1;
      //    this.childcreatedproduct.push({
      //      "productid": data.productid, "index": i
      //    });      
      //}
      //else {

      //  this.childcreatedproduct.push({
      //    "productid": data.productid, "index": i
      //  });

      //}

      //const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
      //this.entry.forEach(container => {
      //  let containerid = container.viewContainerRef.element.nativeElement.id;
      //  const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
      //  this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = data.productid;
      //  myRef.instance['productid'] = data.productid;
      //  myRef.instance['productname'] = data.product;
      //  myRef.instance['directorypath'] = dirpath;
      //});
    }
  }

  //onItemDeSelect(data: Product) {


  //  if (this.selectedProducts.find(x => x.productid == data.productid)) {
  //    this.selectedProducts.splice(this.selectedProducts.findIndex(x => x.productid == data.productid), 1);
  //  }

  //  this.entry.forEach(container => {
  //    if (container.viewContainerRef['_embeddedViews'].length != 0) {
  //      for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
  //        if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.productid == data.productid) {
  //          container.viewContainerRef.remove(i);
  //        }
  //      }
  //    }

  //  });

  //}

  onItemDeSelectAll(data: any) {


    this.conversionInfoContent = false;
    this.selectedProducts = [];
    this.dirPaths = [];

    //$("#conversioninfoContentDiv").remove();

   // this.productclear();
  }

  onItemSelectAll(data: any) {

    if ($("#conversionReqChk").prop('checked')) {
      this.conversionInfo = true
    }

    this.onItemDeSelectAll(data);

    const myFactory = this.resolver.resolveComponentFactory(ProductdetailsComponent);
    //data.forEach(product => {
    //  var id = product.productid;
    //  var i = 0
    //  var dirpathrecord = this.products.find(item => item.productid === product.productid);
    //  var dirpath = dirpathrecord.dirpath;

    //  this.entry.forEach(container => {
    //    let containerid = container.viewContainerRef.element.nativeElement.id;
    //    const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory, data.productid);
    //    this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = product.productid;
    //    myRef.instance['productid'] = product.productid;
    //    myRef.instance['productname'] = product.product;
    //    myRef.instance['directorypath'] = dirpath;
    //  });

    //});

    data.forEach(obj => {
      let existItem = this.selectedProducts.filter(item => item.productid === data.productid);
      if (existItem.length === 0) {
        this.selectedProducts.push(obj)
      }
    });
  }
  counter = 0;
  desiredCompDateChange(event, datectrlid, id, cntrlname, index?) {

    var todayDate = this.datePipe.transform(this.bsInlineValue, "dd/MM/yyyy");
    //console.log(a)
    var selDate = this.datePipe.transform(event, "dd/MM/yyyy");
    if (todayDate === selDate) {
      if (cntrlname == "datecontrollerproduct") {
        if ($('#' + id + index).prop('checked') === false) {
          this.showPopUp(event, datectrlid + index, id + index, cntrlname)
        }
      }
      else {
        if ($('#' + id).prop('checked') === false) {
          this.showPopUp(event, datectrlid, id, cntrlname)
        }
      }
    }
    else {
      if (cntrlname == "datecontrollerproduct") {
        $('#' + id + index).prop('checked', false)
      }
      else {
        $('#' + id).prop('checked', false)
      }
    }

  }

  samedaychange(event, datectrlid, id, cntrlname, index?) {
    //console.log(this.desiredCompDate)

    //;
    if (event.currentTarget.checked) {
      if (cntrlname == "checkboxcontrollerproduct") {
        this.showPopUp(event, datectrlid + index, id + index, cntrlname);
      }
      else {
        this.showPopUp(event, datectrlid, id, cntrlname);
      }

    }
    else {
      //this.requestConfigForm.controls[datectrlid].setValue(null);
      if (cntrlname == "checkboxcontrollerproduct") {
        $('#' + datectrlid + index).val(null);
      }
      else {
        this.requestConfigForm.controls[datectrlid].setValue(null);
      }
    }

  }

  showPopUp(event, datectrlid, id, cntrlname) {
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Same day turnaround will incur additional cost. Are you sure you want to continue?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          //this.desiredCompDate = null
          //event.currentTarget.checked = true
          // $(event.target).prop("checked", true)
          if (cntrlname === 'datecontroller') {
            $('#' + id).prop('checked', true)
            //this.requestConfigForm.controls[id].setValue(this.bsInlineValue);
          }
          if (cntrlname === 'datecontrollerproduct') {
            $('#' + id).prop('checked', true)
            //this.requestConfigForm.controls[id].setValue(this.bsInlineValue);
          }
          if (cntrlname === 'checkboxcontroller') {

            this.requestConfigForm.controls[datectrlid].setValue(this.bsInlineValue);

          }
          if (cntrlname === 'checkboxcontrollerproduct') {
            $('#' + datectrlid).val(this.datePipe.transform(this.bsInlineValue, "MM/dd/yyyy"));
            //this.requestConfigForm.controls[datectrlid].setValue(this.bsInlineValue);

          }
          //this.counter = 0;
          return
          // $(this).prop('checked', true)
        }
        else {
          //event.currentTarget.checked = false
          // $(event.target).prop("checked", false)
          if (cntrlname === 'datecontroller') {
            this.requestConfigForm.controls[datectrlid].setValue(null);
          }
          if (cntrlname === 'datecontrollerproduct') {
            //this.requestConfigForm.controls[datectrlid].setValue(null);
            $('#' + datectrlid).val(null);
          }
          if (cntrlname === 'checkboxcontroller') {
            //this.requestConfigForm.controls[id].setValue(this.bsInlineValue);
            $('#' + id).prop('checked', false)
          }
          if (cntrlname === 'checkboxcontrollerproduct') {
            //this.requestConfigForm.controls[id].setValue(this.bsInlineValue);
            $('#' + id).prop('checked', false)
          }
          //this.requestConfigForm.controls[id].setValue(null);

          // $(this).prop('checked', false)
        }

      });
  }



  loadFileDetails() {
    this.formRenderService.getFormConfig().subscribe(res => {
      if (res != undefined && res.length != 0 && res != null) {

        if (this.formConfigId != null && this.formConfigId != undefined && this.formConfigId != 0) {
          var data = res.filter(e => e.formconfigid == this.formConfigId);
        }
        else {//formconfigname
          var data = res.filter(e => e.formconfigname.toLowerCase() == this.formName.toLowerCase());
          this.formConfigId = data[0].formconfigid;
          //console.log(this.formConfigId);
        }
        if (data.length != 0 && data != null) {
          var htmldata = [];
          htmldata = JSON.parse(data[0].htmldata);
          if (htmldata.length != 0) {
            this.formdashboardservice.getFormDetails(data[0]).subscribe(
              (res) => {
                if ((res != undefined) && (res[0].formdetails != null)) {
                  var s = JSON.parse(res[0].formdetails);
                  var d = s.filter(e => e["Document ID"] == this.documentId);
                  htmldata.forEach(i => {
                    if (i.type == 'file') {
                      if (d.length != 0 && d != undefined) {
                        if (d[0][i.formcontrolname.toLowerCase()] != undefined && d[0][i.formcontrolname.toLowerCase()] != null && d[0][i.formcontrolname.toLowerCase()] != '') {
                          var txt = d[0][i.formcontrolname.toLowerCase()].split('*');
                          if (txt.length != 0) {
                            for (var k = 0; k < txt.length; k++) {
                              this.attachedFileList.push({
                                filenumber: k + 1, filename: txt[k]
                              });
                            }
                          }
                        }
                      }
                    }
                  });
                }
              });
          }
        }
      }
    }, error => { this.toastr.error('Error while getting the form Config  data'); });
  }

  cancelOperation() {
    if (this.operationType === 'update') {
      this.router.navigate(['/home/requestdashboard'])
    }
    else {
      this.requestConfigForm.reset();
      this.conversionInfo = false
      this.selectedProducts = [];
      this.dirPaths = [];

      //$("#conversioninfoContentDiv").remove();

     // this.productclear();
    }
  }

 

  //fileDownload(filename) {
  //  //console.log(this.dbid);
  //  var s = this.databases.filter(e => e.databaseid == this.dbid)
  //  if (s != undefined && s != null && s.length != 0) {
  //    this.requestConfigService.DownloadFile(this.documentId, s[0].database, this.formConfigId, filename).subscribe(res => {
  //      var content = res.file;
  //      let objectURL = 'data:application/octet-stream;base64,' + res.file;
  //      saveAs(objectURL, filename);
  //    });
  //  }
  //}
  fileDownload(filename) {
    //console.log(this.dbid);
    var s = this.databases.filter(e => e.databaseid == this.dbid)
    if (s != undefined && s != null && s.length != 0) {
      let fileData: any = [];
      fileData.push({
        'documentId': this.documentId, 'dbName': s[0].database, 'formConfigId': this.formConfigId, 'fileName': filename
      })
      this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, filename);
      },
        error => { this.toastr.error('File not found'); });

      //this.requestConfigService.DownloadFile(this.documentId, s[0].database, this.formConfigId, filename).subscribe(res => {
      //  var content = res.file;
      //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
      //  saveAs(objectURL, filename);
      //});
    }
  }

  //fileDownloadrequest(filename, type) {

  //  var s = this.databases.filter(e => e.databaseid == this.dbid)
  //  if (s != undefined && s != null && s.length != 0) {
  //    this.requestConfigService.DownloadFileRequest(s[0].database, this.requestDetails[0].requesttype, this.requestdetailid, type, filename).subscribe(res => {
  //      var content = res.file;
  //      let objectURL = 'data:application/octet-stream;base64,' + res.file;
  //      saveAs(objectURL, filename);
  //    });
  //  }
  //}
  fileDownloadrequest(filename, type) {

    var s = this.databases.filter(e => e.databaseid == this.dbid)
    if (s != undefined && s != null && s.length != 0) {
      let requestData: any = [];
      requestData.push({
        'requesttype': this.requestDetails[0].requesttype, 'dbname': s[0].database, 'requestid': this.requestdetailid, 'fileName': filename
      })

      this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, filename);
      },
        error => { this.toastr.error('File not found'); });

      //this.requestConfigService.DownloadFileRequest(s[0].database, this.requestDetails[0].requesttype, this.requestdetailid, type, filename).subscribe(res => {
      //  var content = res.file;
      //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
      //  saveAs(objectURL, filename);
      //});
    }
  }
  

  onFileSelect(fileInput: any) {
    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.finaluploadfilename = file.name;
      this.requestConfigForm.get('conversionFile').setValue(file);
    }

  }
  onFileSelectcreate(fileInput: any) {

    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.attachfileName = file.name;
      this.requestConfigForm.get('dtlsFileUpld').setValue(file);
    }

  }
  onFileSelectconversioncreate(fileInput: any) {

    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.attachconversionfileName = file.name;
      this.requestConfigForm.get('conversionreqattachfile').setValue(file);
    }

  }

}
